import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SnackbarService, Toast } from '@core/services/snackbar.service';

@Component({
  standalone: false,
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: (Toast & { id: number; removing: boolean })[] = [];
  private sub!: Subscription;
  private counter = 0;

  constructor(private snackbarService: SnackbarService) {}

  ngOnInit(): void {
    this.sub = this.snackbarService.toasts$.subscribe(toast => {
      const id = ++this.counter;
      const entry = { ...toast, id, removing: false };
      this.toasts.push(entry);
      setTimeout(() => this.remove(id), toast.duration ?? 4000);
    });
  }

  remove(id: number): void {
    const t = this.toasts.find(x => x.id === id);
    if (!t || t.removing) return;
    t.removing = true;
    setTimeout(() => {
      this.toasts = this.toasts.filter(x => x.id !== id);
    }, 380);
  }

  trackById(_: number, t: any) { return t.id; }

  ngOnDestroy(): void { this.sub?.unsubscribe(); }
}
